import { useTracker } from '../lib/useTracker';
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthProvider';
import { useScreen } from '../lib/useScreen';
import { useTheme } from '../lib/useTheme';
import { useGenioLuca } from '../lib/useGenioLuca';
import TermsModal from '../lib/TermsModal';
import { supabase } from '../lib/supabaseClient';
import SocialMetrics from '../lib/SocialMetrics';
import SalesModule from '../lib/SalesModule';
import AutoReminders from '../lib/AutoReminders';
import UserAvatar from '../lib/UserAvatar';
import ProfileGate from '../lib/ProfileGate';
import { GenioLucaHint, PlaceholderTasks, PlaceholderSales, PlaceholderDonut, PlaceholderBars } from '../lib/PlaceholderData';
import ProfileReminders from '../lib/ProfileReminders';
import SidebarLayout from '../lib/SidebarLayout';
import TeamBoard from '../lib/TeamBoard';
import TipBanner from '../lib/TipBanner';
import SharedTaskList from '../components/admin/SharedTaskList';
import RentalCalendar from '../lib/RentalCalendar';
import { compressImage } from '../lib/compressImage';
import PushPrompt from '../lib/PushPrompt';

import { C, font, serif, HCard } from '../components/shared';

const CALENDARIO = [
  { dia:'Lun', fecha:7, estado:null },{ dia:'Mar', fecha:8, estado:null },{ dia:'Mié', fecha:9, estado:null },
  { dia:'Jue', fecha:10, estado:null },{ dia:'Vie', fecha:11, estado:null },{ dia:'Sáb', fecha:12, estado:null },{ dia:'Dom', fecha:13, estado:null },
];
const monthlyData = [];

function Bar() { return <div style={{ width:4, height:24, borderRadius:2, background:C.triGrad, flexShrink:0 }}/>; }

/* HCard imported from shared */

export default function EscritorioOnsite() {
  const navigate = useNavigate();
  const { user, profile, signOut, refreshProfile, membership } = useAuth();
  useTracker("escritorio_onsite", user?.id);
  const { isMobile } = useScreen();
  const t = useTheme();
  const [tareas, setTareas] = useState([]);
  const [showAddTask, setShowAddTask] = useState(false);
  const [newTaskText, setNewTaskText] = useState('');
  const [newTaskPrio, setNewTaskPrio] = useState('turquesa');
  const [chatOpen, setChatOpen] = useState(false);
  const [chatInput, setChatInput] = useState('');
  const { chatMsgs, chatLoading, sendMessage } = useGenioLuca(profile, []);
  const [metricTab, setMetricTab] = useState('Instagram');
  const [lightbox, setLightbox] = useState(null);
  const [section, setSection] = useState('home');
  const [showComingSoon, setShowComingSoon] = useState(false);
  const [projectStory, setProjectStory] = useState('');
  const [projectPhotos, setProjectPhotos] = useState([]);
  const [uploadingPhotos, setUploadingPhotos] = useState(false);
  const [savingStory, setSavingStory] = useState(false);
  const [entregables, setEntregables] = useState([]);
  // Sales state
  const [saleProduct, setSaleProduct] = useState('');
  const [salePrice, setSalePrice] = useState('');
  const [saleChannel, setSaleChannel] = useState('store');
  const [saleDate, setSaleDate] = useState(new Date().toISOString().split('T')[0]);
  const [saleConfirm, setSaleConfirm] = useState(null);
  const [receiptSale, setReceiptSale] = useState(null);
  const [todaySales, setTodaySales] = useState([]);

  const nombre = profile?.full_name?.split(' ')[0] || user?.user_metadata?.full_name?.split(' ')[0] || 'ahí';

  // Fetch entregables from Supabase
  useEffect(() => {
    if (!user) return;
    supabase.from('deliverables').select('*').eq('user_id', user.id).order('created_at', { ascending: false }).then(({ data }) => {
      if (data) setEntregables(data);
    });
  }, [user]);

  // Sync project story & photos from profile
  useEffect(() => {
    if (!profile) return;
    setProjectStory(profile.project_story || '');
    setProjectPhotos(profile.project_photos || []);
  }, [profile]);

  /* Tour removed */
  const prioColor = { coral:C.coral, mango:C.mango, turquesa:C.turquesa };
  const calColor = { publicado:C.turquesa, programado:C.mango, pendiente:C.coral };
  const estadoColor = { entregado:C.turquesa, proceso:C.mango, pendiente:C.coral };
  const estadoLabel = { entregado:'Entregado', proceso:'En proceso', pendiente:'Pendiente' };
  const todayTotal = todaySales.reduce((s,v)=>s+v.price, 0);
  const maxBar = Math.max(...monthlyData.map(d=>d.mostrador+d.internet));

  const toggleTarea = (id) => setTareas(prev => prev.map(ta => ta.id===id ? {...ta, done:!ta.done} : ta));
  const deleteTarea = (id) => setTareas(prev => prev.filter(ta => ta.id !== id));
  const addTarea = () => {
    if (!newTaskText.trim()) return;
    setTareas(prev => [{ id:Date.now(), texto:newTaskText, detalle:'', prioridad:newTaskPrio, done:false, source:'manual' }, ...prev]);
    setNewTaskText(''); setNewTaskPrio('turquesa'); setShowAddTask(false);
  };
  const sortedTareas = [...tareas].sort((a,b) => a.done === b.done ? 0 : a.done ? 1 : -1);

  const generateFolio = (date) => {
    const d = date.replace(/-/g, '');
    return `TD-${d}-${String(todaySales.filter(s=>s.date===date).length+1).padStart(4,'0')}`;
  };
  const registerSale = () => {
    if (!saleProduct.trim() || !salePrice) return;
    const now = new Date();
    const folio = generateFolio(saleDate);
    const newSale = { id:Date.now(), product:saleProduct, price:Number(salePrice), channel:saleChannel, date:saleDate, time:now.toLocaleTimeString('es-MX',{hour:'2-digit',minute:'2-digit'}), folio };
    setTodaySales(prev=>[newSale,...prev]);
    setReceiptSale(newSale);
    setSaleConfirm(`✓ ${folio} — ${saleProduct} $${Number(salePrice).toLocaleString()}`);
    setSaleProduct(''); setSalePrice(''); setSaleChannel('store');
    setTimeout(()=>setSaleConfirm(null), 3000);
  };
  const printReceipt = () => {
    const style = document.createElement('style');
    style.id = 'td-print';
    style.textContent = `@media print { body * { visibility:hidden !important; } #td-receipt, #td-receipt * { visibility:visible !important; } #td-receipt { position:fixed !important; left:0 !important; top:0 !important; width:80mm !important; padding:4mm !important; margin:0 !important; font-size:11px !important; color:#000 !important; background:#fff !important; } }`;
    document.head.appendChild(style);
    window.print();
    setTimeout(()=>style.remove(), 500);
  };
  const downloadPDF = async () => {
    const el = document.getElementById('td-receipt');
    if (!el || !window.html2canvas || !window.jspdf) return;
    const canvas = await window.html2canvas(el, { scale:2, backgroundColor:'#fff' });
    const img = canvas.toDataURL('image/png');
    const h = canvas.height * 80 / canvas.width;
    const pdf = new window.jspdf.jsPDF({ unit:'mm', format:[80, h] });
    pdf.addImage(img, 'PNG', 0, 0, 80, h);
    pdf.save('ticket-' + (receiptSale?.folio || 'ticket') + '.pdf');
  };
  const shareTicket = async () => {
    const el = document.getElementById('td-receipt');
    if (!el || !window.html2canvas) return;
    const canvas = await window.html2canvas(el, { scale:2, backgroundColor:'#fff' });
    canvas.toBlob(async (blob) => {
      const folio = receiptSale?.folio || 'ticket';
      const file = new File([blob], 'ticket-' + folio + '.png', { type:'image/png' });
      if (navigator.share && navigator.canShare && navigator.canShare({ files:[file] })) {
        await navigator.share({ title:'Ticket de venta', text:'Gracias por tu compra en ' + (profile?.business_name||'T&D') + ' - Folio: ' + folio, files:[file] });
      } else {
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a'); a.href = url; a.download = 'ticket-' + folio + '.png'; a.click();
        URL.revokeObjectURL(url);
      }
    }, 'image/png');
  };
  const exportCSV = () => {
    const rows = [['Fecha','Producto','Precio','Canal','Folio']];
    todaySales.forEach(s => rows.push([s.date, s.product, s.price, s.channel==='store'?'Mostrador':'Internet', s.folio||'']));
    const blob = new Blob([rows.map(r=>r.join(',')).join('\n')],{type:'text/csv'});
    const a = document.createElement('a'); a.href=URL.createObjectURL(blob); a.download='ventas_onsite_td.csv'; a.click();
  };

  const MENU = [
    { id:'home', emoji:'🏠', label:'Mi escritorio' },
    { id:'proyecto', emoji:'📦', label:'Mi proyecto' },
    { id:'ventas', emoji:'💰', label:'Ventas' },
    ...((profile?.sales_type === 'rentas' || profile?.sales_type === 'boletos') ? [{ id:'calendario', emoji:'📅', label:'Calendario' }] : []),
    { id:'metricas', emoji:'📊', label:'Métricas' },
    { id:'equipo', emoji:'👥', label:'Equipo' },
    { id:'pendientes', emoji:'📋', label:'Pendientes T&D' },
    { id:'perfil', type:'link', emoji:'👤', label:'Mi perfil', href:'/perfil' },
    { id:'sala', type:'link', emoji:'🏛', label:'La Sala', href:'/sala' },
  ];

  /* Terms modal — only show if column exists and is explicitly false */
  if (user && profile && profile.accepted_terms === false && membership !== 'admin') {
    return <TermsModal userId={user.id} onAccept={() => refreshProfile()} />;
  }

  return (
    <ProfileGate>
    <SidebarLayout menuItems={MENU} activeSection={section} onSectionChange={setSection} title="Onsite">

      {section === 'home' && <>
        {/* HEADER */}
        <section style={{ padding:isMobile?'1.5rem 0':'2rem 0', display:'flex', alignItems:'center', justifyContent:'space-between', flexWrap:'wrap', gap:16 }}>
          <div>
            <p style={{ fontSize:13, color:t.textSecondary, margin:'0 0 4px' }}>Mi escritorio</p>
            <h1 style={{ fontFamily:serif, fontSize:isMobile?22:28, fontWeight:400, margin:'0 0 6px' }}>Onsite Growth México</h1>
            <span style={{ display:'inline-block', fontSize:11, fontWeight:600, padding:'4px 14px', borderRadius:20, background:C.triGrad, color:'#fff' }}>Premium · Presencial</span>
          </div>
          <UserAvatar url={profile?.avatar_url} name={nombre} size={50} />
        </section>

        <GenioLucaHint userId={user?.id} t={t} />
        <ProfileReminders/>
        <AutoReminders/>
        <TipBanner membership="onsite_mexico" />

      </>}

      {section === 'proyecto' && <>
        {/* ═══ CUENTA TU HISTORIA + FOTOS ═══ */}
        <section style={{ marginBottom:'2.5rem' }}>
          <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4 }}><Bar/><h2 style={{ fontFamily:serif, fontSize:isMobile?18:22, fontWeight:400, margin:0 }}>Cuenta tu historia</h2></div>
          <p style={{ fontSize:13, color:t.textSecondary, margin:'0 0 12px', paddingLeft:12 }}>Describe tu proyecto, tu camino y lo que has aprendido</p>
          <textarea
            value={projectStory}
            onChange={e => setProjectStory(e.target.value)}
            placeholder="Escribe la historia de tu proyecto..."
            style={{
              width:'100%', minHeight:140, padding:16, fontFamily:font, fontSize:14,
              borderRadius:14, border:`1px solid ${t.border}`, background:t.card, color:t.text,
              resize:'vertical', outline:'none', boxSizing:'border-box', lineHeight:1.6,
            }}
          />

          <div style={{ display:'flex', alignItems:'center', gap:8, marginTop:24, marginBottom:4 }}><Bar/><h2 style={{ fontFamily:serif, fontSize:isMobile?18:22, fontWeight:400, margin:0 }}>Sube fotos de tu proceso</h2></div>
          <p style={{ fontSize:13, color:t.textSecondary, margin:'0 0 12px', paddingLeft:12 }}>Máximo 10 imágenes que muestren tu progreso</p>

          {projectPhotos.length < 10 && (
            <label style={{
              display:'inline-flex', alignItems:'center', gap:8, cursor:'pointer',
              padding:'10px 20px', borderRadius:12, background:C.turquesa+'15', color:C.turquesa,
              fontWeight:600, fontSize:13, marginBottom:16, border:`1.5px dashed ${C.turquesa}`,
            }}>
              📷 Seleccionar imágenes
              <input
                type="file"
                accept="image/*"
                multiple
                style={{ display:'none' }}
                onChange={async (e) => {
                  const files = Array.from(e.target.files);
                  if (!files.length) return;
                  const remaining = 10 - projectPhotos.length;
                  const toUpload = files.slice(0, remaining);
                  setUploadingPhotos(true);
                  const newUrls = [];
                  for (let file of toUpload) {
                    file = await compressImage(file);
                    const ext = file.name.split('.').pop();
                    const path = `${user.id}/${Date.now()}_${Math.random().toString(36).slice(2,8)}.${ext}`;
                    const { error } = await supabase.storage.from('project-photos').upload(path, file);
                    if (!error) {
                      const { data: urlData } = supabase.storage.from('project-photos').getPublicUrl(path);
                      if (urlData?.publicUrl) newUrls.push(urlData.publicUrl);
                    }
                  }
                  if (newUrls.length) setProjectPhotos(prev => [...prev, ...newUrls]);
                  setUploadingPhotos(false);
                  e.target.value = '';
                }}
              />
            </label>
          )}
          {uploadingPhotos && <p style={{ fontSize:13, color:C.turquesa, margin:'8px 0' }}>Subiendo imágenes...</p>}

          {projectPhotos.length > 0 && (
            <div style={{ display:'grid', gridTemplateColumns:isMobile?'repeat(2,1fr)':'repeat(4,1fr)', gap:12, marginTop:12 }}>
              {projectPhotos.map((url, i) => (
                <div key={i} style={{ position:'relative', borderRadius:12, overflow:'hidden', aspectRatio:'1', background:t.isDark?'#222':'#f5f5f5' }}>
                  <img src={url} alt={`Foto ${i+1}`} style={{ width:'100%', height:'100%', objectFit:'cover', display:'block' }} />
                  <button
                    onClick={async () => {
                      const pathMatch = url.split('/project-photos/')[1];
                      if (pathMatch) {
                        await supabase.storage.from('project-photos').remove([decodeURIComponent(pathMatch)]);
                      }
                      setProjectPhotos(prev => prev.filter((_, idx) => idx !== i));
                    }}
                    style={{
                      position:'absolute', top:6, right:6, width:26, height:26, borderRadius:'50%',
                      background:'rgba(0,0,0,0.55)', color:'#fff', border:'none', cursor:'pointer',
                      display:'flex', alignItems:'center', justifyContent:'center', fontSize:14, fontWeight:700,
                    }}
                  >×</button>
                </div>
              ))}
            </div>
          )}

          <button
            disabled={savingStory}
            onClick={async () => {
              setSavingStory(true);
              await supabase.from('profiles').update({
                project_story: projectStory,
                project_photos: projectPhotos,
              }).eq('id', user.id);
              await refreshProfile();
              setSavingStory(false);
            }}
            style={{
              marginTop:20, padding:'12px 32px', borderRadius:12, border:'none', cursor:'pointer',
              background:C.turquesa, color:'#fff', fontFamily:font, fontSize:14, fontWeight:600,
              opacity:savingStory?0.6:1,
            }}
          >
            {savingStory ? 'Guardando...' : 'Guardar historia y fotos'}
          </button>
        </section>

        {/* ═══ ENTREGABLES (ONSITE EXCLUSIVE) ═══ */}
        <section style={{ marginBottom:'2.5rem' }}>
          <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:4 }}><Bar/><h2 style={{ fontFamily:serif, fontSize:isMobile?18:22, fontWeight:400, margin:0 }}>Entregables de tu proyecto</h2></div>
          <p style={{ fontSize:13, color:t.textSecondary, margin:'0 0 16px', paddingLeft:12 }}>Todo el material que hemos creado para tu negocio</p>
          {entregables.length > 0 ? (
            <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr', gap:12 }}>
              {entregables.map(e=>{
                const icons = {documento:'📄',logo:'🎨',video:'🎬',fotos:'📸',estrategia:'📋',identidad:'🎨'};
                const sc = estadoColor[e.status]||'#999';
                return (
                  <HCard key={e.id} t={t} style={{ padding:'16px 18px', display:'flex', alignItems:'center', gap:14 }}>
                    <div style={{ width:44, height:44, borderRadius:12, background:sc+'15', display:'flex', alignItems:'center', justifyContent:'center', fontSize:22, flexShrink:0 }}>{icons[e.type]||'📦'}</div>
                    <div style={{ flex:1, minWidth:0 }}>
                      <p style={{ fontSize:14, fontWeight:500, margin:'0 0 2px', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>{e.title}</p>
                      <p style={{ fontSize:12, color:t.textSecondary, margin:0 }}>{e.delivery_date||'Pendiente'}</p>
                    </div>
                    <div style={{ display:'flex', flexDirection:'column', alignItems:'flex-end', gap:4 }}>
                      <span style={{ fontSize:10, fontWeight:600, padding:'2px 10px', borderRadius:10, background:sc+'18', color:sc }}>{estadoLabel[e.status]||e.status}</span>
                      {e.link_url && <a href={e.link_url} target="_blank" rel="noopener noreferrer" style={{ fontSize:12, color:C.turquesa, fontWeight:500 }}>Ver</a>}
                    </div>
                  </HCard>
                );
              })}
            </div>
          ) : (
            <div style={{ opacity:0.7 }}>
              <span style={{ display:'inline-block', fontSize:11, padding:'2px 10px', borderRadius:10, background:t.isDark?'#333':'#eee', color:t.textSecondary, marginBottom:10 }}>📋 Ejemplo</span>
              <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr', gap:12 }}>
                {[
                  {icon:'🎨',title:'Identidad de marca',date:'15 mar',status:'entregado'},
                  {icon:'🎬',title:'Video promocional',date:'En edición',status:'proceso'},
                  {icon:'📸',title:'Sesión de fotos producto',date:'Pendiente',status:'pendiente'},
                  {icon:'📄',title:'Estrategia de redes Q2',date:'Pendiente',status:'pendiente'},
                ].map((e,i)=>(
                  <HCard key={i} t={t} style={{ padding:'14px 18px', display:'flex', alignItems:'center', gap:14, border:`1.5px dashed ${t.border}` }}>
                    <div style={{ width:44, height:44, borderRadius:12, background:(estadoColor[e.status]||'#999')+'15', display:'flex', alignItems:'center', justifyContent:'center', fontSize:22, flexShrink:0 }}>{e.icon}</div>
                    <div style={{ flex:1 }}>
                      <p style={{ fontSize:14, fontWeight:500, margin:'0 0 2px' }}>{e.title}</p>
                      <p style={{ fontSize:12, color:t.textSecondary, margin:0 }}>{e.date}</p>
                    </div>
                    <span style={{ fontSize:10, fontWeight:600, padding:'2px 10px', borderRadius:10, background:(estadoColor[e.status]||'#999')+'18', color:estadoColor[e.status]||'#999' }}>{estadoLabel[e.status]||e.status}</span>
                  </HCard>
                ))}
              </div>
            </div>
          )}
        </section>

        {/* ═══ HISTORIAL DE VISITAS ═══ */}
        <section style={{ marginBottom:'2.5rem' }}>
          <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:16 }}><Bar/><h2 style={{ fontFamily:serif, fontSize:isMobile?18:22, fontWeight:400, margin:0 }}>Historial de visitas</h2></div>
          <div style={{ opacity:0.7 }}>
            <span style={{ display:'inline-block', fontSize:11, padding:'2px 10px', borderRadius:10, background:t.isDark?'#333':'#eee', color:t.textSecondary, marginBottom:10 }}>📋 Ejemplo</span>
            <div style={{ position:'relative', paddingLeft:24 }}>
              <div style={{ position:'absolute', left:7, top:0, bottom:0, width:2, background:C.triGrad, borderRadius:1 }}/>
              {[
                {fecha:'28 mar 2026',titulo:'Visita inicial',desc:'Diagnóstico presencial, levantamiento de contenido, definición de marca.'},
                {fecha:'5 abr 2026',titulo:'Segunda visita',desc:'Revisión de marca, entrega de material audiovisual.'},
              ].map((v,i)=>(
                <div key={i} style={{ position:'relative', marginBottom:i===0?24:0 }}>
                  <div style={{ position:'absolute', left:-24, top:4, width:16, height:16, borderRadius:'50%', background:t.card, border:`3px solid ${C.turquesa}`, zIndex:1 }}/>
                  <HCard t={t} style={{ padding:'14px 18px' }}>
                    <p style={{ fontSize:12, color:C.turquesa, fontWeight:600, margin:'0 0 4px' }}>{v.fecha}</p>
                    <p style={{ fontSize:15, fontWeight:500, margin:'0 0 4px' }}>{v.titulo}</p>
                    <p style={{ fontSize:13, color:t.textSecondary, lineHeight:1.6, margin:0 }}>{v.desc}</p>
                  </HCard>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ═══ CONTENIDO PRODUCIDO ═══ */}
        <section style={{ marginBottom:'2.5rem' }}>
          <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:16 }}><Bar/><h2 style={{ fontFamily:serif, fontSize:isMobile?18:22, fontWeight:400, margin:0 }}>Contenido producido</h2></div>
          <div style={{ opacity:0.7 }}>
            <span style={{ display:'inline-block', fontSize:11, padding:'2px 10px', borderRadius:10, background:t.isDark?'#333':'#eee', color:t.textSecondary, marginBottom:10 }}>📋 Ejemplo</span>
            <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
              {[
                {emoji:'📱',title:'Reel de presentación',red:'Instagram',estado:'Publicado ✓'},
                {emoji:'📱',title:'Video de proceso',red:'TikTok',estado:'Programado'},
                {emoji:'📷',title:'Fotos de producto x10',red:'Instagram',estado:'Publicado ✓'},
              ].map((c,i)=>(
                <HCard key={i} t={t} style={{ padding:'12px 18px', display:'flex', alignItems:'center', gap:12, border:`1.5px dashed ${t.border}` }}>
                  <span style={{ fontSize:20 }}>{c.emoji}</span>
                  <div style={{ flex:1 }}>
                    <p style={{ fontSize:14, fontWeight:500, margin:0 }}>{c.title}</p>
                    <p style={{ fontSize:12, color:t.textSecondary, margin:0 }}>{c.red}</p>
                  </div>
                  <span style={{ fontSize:11, fontWeight:500, color:c.estado.includes('✓')?C.turquesa:C.mango }}>{c.estado}</span>
                </HCard>
              ))}
            </div>
          </div>
        </section>

      </>}

      {section === 'home' && <>
        {/* TAREAS */}
        <section style={{ marginBottom:'2.5rem' }}>
          <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:16 }}><Bar/><h2 style={{ fontFamily:serif, fontSize:isMobile?18:22, fontWeight:400, margin:0 }}>Qué tienes pendiente hoy</h2></div>
          <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
            {sortedTareas.length === 0 && !showAddTask && <PlaceholderTasks t={t} />}
            {sortedTareas.map(ta=>(
              <HCard key={ta.id} t={t} style={{ padding:'14px 18px', borderLeft:`4px solid ${prioColor[ta.prioridad]}`, display:'flex', alignItems:'center', gap:14 }}>
                <div onClick={()=>toggleTarea(ta.id)} style={{ width:22, height:22, borderRadius:6, border:`2px solid ${ta.done?C.turquesa:t.border}`, background:ta.done?C.turquesa:'none', display:'flex', alignItems:'center', justifyContent:'center', cursor:'pointer', flexShrink:0 }}>
                  {ta.done && <span style={{ color:'#fff', fontSize:12, fontWeight:700 }}>✓</span>}
                </div>
                <div style={{ flex:1 }}>
                  <p style={{ fontSize:14, fontWeight:500, margin:0, textDecoration:ta.done?'line-through':'none', opacity:ta.done?0.5:1 }}>{ta.texto}</p>
                  {ta.detalle && <p style={{ fontSize:12, color:t.textSecondary, margin:'2px 0 0' }}>{ta.detalle}</p>}
                </div>
                <button onClick={()=>deleteTarea(ta.id)} style={{ background:'none', border:'none', color:t.textSecondary, fontSize:16, cursor:'pointer', padding:'0 4px', opacity:0.4 }}>×</button>
              </HCard>
            ))}
            {showAddTask ? (
              <HCard t={t} style={{ padding:'14px 18px' }}>
                <input value={newTaskText} onChange={e=>setNewTaskText(e.target.value)} onKeyDown={e=>e.key==='Enter'&&addTarea()} autoFocus placeholder="¿Qué necesitas hacer?" style={{ width:'100%', padding:'8px 0', border:'none', outline:'none', fontSize:14, fontFamily:font, background:'transparent', color:t.text, marginBottom:10 }}/>
                <div style={{ display:'flex', gap:8, alignItems:'center', flexWrap:'wrap' }}>
                  <div style={{ display:'flex', gap:4 }}>
                    {[{k:'coral',l:'Alta'},{k:'mango',l:'Media'},{k:'turquesa',l:'Normal'}].map(p=>(
                      <button key={p.k} onClick={()=>setNewTaskPrio(p.k)} style={{ padding:'4px 12px', fontSize:11, fontWeight:500, borderRadius:50, cursor:'pointer', fontFamily:font, border:newTaskPrio===p.k?`2px solid ${prioColor[p.k]}`:`1px solid ${t.border}`, background:newTaskPrio===p.k?prioColor[p.k]+'18':'none', color:newTaskPrio===p.k?prioColor[p.k]:t.textSecondary }}>{p.l}</button>
                    ))}
                  </div>
                  <button onClick={addTarea} style={{ background:C.logoGrad, color:'#fff', border:'none', borderRadius:50, padding:'6px 18px', fontSize:12, fontWeight:500, cursor:'pointer', fontFamily:font }}>Agregar</button>
                  <button onClick={()=>{setShowAddTask(false);setNewTaskText('')}} style={{ background:'none', border:'none', color:t.textSecondary, fontSize:12, cursor:'pointer', fontFamily:font }}>Cancelar</button>
                </div>
              </HCard>
            ) : (
              <button onClick={()=>setShowAddTask(true)} style={{ background:'none', border:`1px dashed ${t.border}`, borderRadius:20, padding:'12px', fontSize:13, fontWeight:500, color:C.turquesa, cursor:'pointer', fontFamily:font, textAlign:'center' }}>+ Agregar tarea</button>
            )}
          </div>
        </section>

      </>}

      {section === 'metricas' && <>
        {/* SOCIAL METRICS */}
        <SocialMetrics userId={user?.id} profile={profile}/>

        {false && <section style={{ marginBottom:'2.5rem' }}>
          <HCard t={t} style={{ padding:isMobile?'1rem':'1.25rem' }}>
            <div>
              <p style={{ fontSize:14, fontWeight:500, margin:'0 0 4px' }}>Conecta tus redes para ver métricas reales</p>
              <p style={{ fontSize:12, color:t.textSecondary, margin:0 }}>Vincula tus cuentas y ve tus números en tiempo real</p>
            </div>
            <div style={{ display:'flex', gap:8, flexWrap:'wrap' }}>
              {[{name:'Instagram',emoji:'📸'},{name:'TikTok',emoji:'🎵'},{name:'Facebook',emoji:'👍'}].map(s=>(
                <button key={s.name} onClick={()=>setShowComingSoon(true)} style={{ background:t.card, border:`0.5px solid ${t.border}`, borderRadius:50, padding:'7px 14px', fontSize:12, fontWeight:500, cursor:'pointer', fontFamily:font, color:t.text, display:'flex', alignItems:'center', gap:5 }}>
                  <span>{s.emoji}</span>{!isMobile && 'Conectar '+s.name}
                </button>
              ))}
            </div>
          </HCard>
        </section>}

        {/* PROGRAMA 90 DÍAS */}
        <section style={{ marginBottom:'2.5rem' }}>
          <HCard t={t} style={{ padding:isMobile?'1.25rem':'1.5rem' }}>
            <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:14 }}><Bar/><h3 style={{ fontFamily:serif, fontSize:18, fontWeight:400, margin:0 }}>Programa 90 días</h3></div>
            <div style={{ display:'flex', alignItems:'baseline', gap:8, marginBottom:8 }}>
              <span style={{ fontSize:36, fontWeight:500 }}>72%</span>
              <span style={{ fontSize:13, color:t.textSecondary }}>Semana 10 de 13</span>
            </div>
            <p style={{ fontSize:14, fontWeight:500, margin:'0 0 10px' }}>Implementación de estrategia</p>
            <div style={{ background:t.isDark?'#333':'#f0f0ed', borderRadius:99, height:8, overflow:'hidden' }}>
              <div style={{ background:C.logoGrad, height:'100%', width:'72%', borderRadius:99 }}/>
            </div>
          </HCard>
        </section>
        {false && <HCard t={t} style={{ padding:isMobile?'1.25rem':'1.5rem' }}>
            <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:14 }}><Bar/><h3 style={{ fontFamily:serif, fontSize:18, fontWeight:400, margin:0 }}>Métricas de redes</h3></div>
            <div style={{ display:'flex', gap:6, marginBottom:14 }}>
              {['Instagram','TikTok','Facebook'].map(tab=>(
                <button key={tab} onClick={()=>setMetricTab(tab)} style={{ background:metricTab===tab?C.turquesa+'18':'none', border:`0.5px solid ${metricTab===tab?C.turquesa:t.border}`, borderRadius:50, padding:'4px 12px', fontSize:11, fontWeight:500, cursor:'pointer', fontFamily:font, color:metricTab===tab?C.turquesa:t.textSecondary }}>{tab}</button>
              ))}
            </div>
            <div style={{ textAlign:'center', padding:'16px 0' }}>
              <p style={{ fontSize:24, margin:'0 0 6px' }}>📊</p>
              <p style={{ fontSize:13, color:t.textSecondary, margin:0 }}>Conecta tus redes para ver métricas reales</p>
            </div>
          </HCard>}

      </>}

      {section === 'ventas' && <>
        <SalesModule userId={user?.id} profile={profile}/>
      </>}

      {section === 'calendario' && <RentalCalendar userId={user?.id} profile={profile} />}

      {section === 'metricas' && <>
        {/* CALENDARIO */}
        <section style={{ marginBottom:'2.5rem' }}>
          <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:16 }}><Bar/><h2 style={{ fontFamily:serif, fontSize:isMobile?18:22, fontWeight:400, margin:0 }}>Calendario de contenido</h2></div>
          <HCard t={t} style={{ padding:isMobile?'1rem':'1.5rem' }}>
            <div style={{ display:'grid', gridTemplateColumns:'repeat(7, 1fr)', gap:isMobile?4:8, marginBottom:12 }}>
              {CALENDARIO.map((d,i)=>(
                <div key={i} style={{ textAlign:'center' }}>
                  <p style={{ fontSize:11, color:t.textSecondary, margin:'0 0 6px' }}>{d.dia}</p>
                  <div style={{ width:isMobile?36:44, height:isMobile?36:44, borderRadius:12, margin:'0 auto', background:d.estado?calColor[d.estado]:t.isDark?'#333':'#f0f0ed', color:d.estado?'#fff':t.text, border:d.estado?'none':`1px solid ${t.border}`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:isMobile?14:16, fontWeight:500 }}>{d.fecha}</div>
                </div>
              ))}
            </div>
          </HCard>
        </section>

        {/* DIAGNÓSTICO */}
        <section style={{ marginBottom:'2.5rem' }}>
          <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:16 }}><Bar/><h2 style={{ fontFamily:serif, fontSize:isMobile?18:22, fontWeight:400, margin:0 }}>Diagnóstico inteligente</h2></div>
          <HCard t={t} style={{ padding:isMobile?'1.25rem':'1.5rem' }}>
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', flexWrap:'wrap', gap:10, marginBottom:14 }}>
              <div>
                <p style={{ fontSize:13, color:t.textSecondary, margin:'0 0 2px' }}>Último diagnóstico: pendiente</p>
                <p style={{ fontSize:13, color:C.turquesa, fontWeight:500, margin:0 }}>Próximo disponible: cuando conectes tus redes</p>
              </div>
              <button disabled style={{ background:t.isDark?'#333':'#f0f0ed', border:'none', borderRadius:50, padding:'8px 18px', fontSize:12, fontWeight:500, color:t.textSecondary, fontFamily:font, cursor:'not-allowed', opacity:0.6 }}>Pedir diagnóstico</button>
            </div>
            <div style={{ background:t.isDark?'#333':'#f8f8f6', borderRadius:14, padding:'14px 16px' }}>
              <p style={{ fontSize:13, color:t.textSecondary, lineHeight:1.6, margin:0 }}>📊 Tu diagnóstico inteligente estará disponible cuando conectes tus redes sociales y registres ventas.</p>
            </div>
          </HCard>
        </section>

      </>}

      {section === 'home' && <>
        {/* PROCESOS */}
        <section style={{ marginBottom:'2.5rem' }}>
          <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:16 }}><Bar/><h2 style={{ fontFamily:serif, fontSize:isMobile?18:22, fontWeight:400, margin:0 }}>Procesos del proyecto</h2></div>
          <div style={{ display:'grid', gridTemplateColumns:isMobile?'1fr':'1fr 1fr', gap:12 }}>
            {/* Placeholder processes */}
            {[{nombre:'Ej: Atención al cliente',c:2,t:5},{nombre:'Ej: Proceso de ventas',c:0,t:4}].map((p,i)=>{
              const pct=p.t>0?(p.c/p.t)*100:0;
              return (
                <HCard key={i} t={t} style={{ padding:'14px 18px', opacity:0.7, border:`1.5px dashed ${t.border}` }}>
                  <div style={{ display:'flex', justifyContent:'space-between', marginBottom:8 }}><p style={{ fontSize:14, fontWeight:500, margin:0 }}>{p.nombre}</p><span style={{ fontSize:13, fontWeight:600, color:t.textSecondary }}>{p.c}/{p.t}</span></div>
                  <div style={{ background:t.isDark?'#333':'#f0f0ed', borderRadius:99, height:6, overflow:'hidden' }}><div style={{ background:t.textSecondary, height:'100%', width:`${pct}%`, borderRadius:99 }}/></div>
                </HCard>
              );
            })}
          </div>
        </section>

        {/* BARRAS 6 MESES */}
        <section style={{ marginBottom:'2.5rem' }}>
          <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:16 }}><Bar/><h2 style={{ fontFamily:serif, fontSize:isMobile?18:22, fontWeight:400, margin:0 }}>Tendencia de ventas</h2></div>
          <HCard t={t} style={{ padding:'1.25rem' }}>
            <div style={{ display:'flex', alignItems:'flex-end', gap:isMobile?6:10, height:120 }}>
              {monthlyData.map((d,i)=>(
                <div key={i} style={{ flex:1, display:'flex', flexDirection:'column', alignItems:'center', gap:2 }}>
                  <div style={{ width:'100%', display:'flex', gap:2, alignItems:'flex-end', height:100 }}>
                    <div style={{ flex:1, height:`${maxBar>0?(d.mostrador/maxBar)*100:0}%`, background:C.coral, borderRadius:'4px 4px 0 0', minHeight:2 }}/>
                    <div style={{ flex:1, height:`${maxBar>0?(d.internet/maxBar)*100:0}%`, background:C.turquesa, borderRadius:'4px 4px 0 0', minHeight:2 }}/>
                  </div>
                  <span style={{ fontSize:10, color:t.textSecondary }}>{d.mes}</span>
                </div>
              ))}
            </div>
            <div style={{ display:'flex', gap:14, marginTop:10, fontSize:11, color:t.textSecondary }}>
              <span><span style={{ display:'inline-block', width:8, height:8, borderRadius:2, background:C.coral, marginRight:4 }}/>Mostrador</span>
              <span><span style={{ display:'inline-block', width:8, height:8, borderRadius:2, background:C.turquesa, marginRight:4 }}/>Internet</span>
            </div>
          </HCard>
        </section>
      </>}

      {section === 'equipo' && <TeamBoard userId={user?.id}/>}

      {section === 'pendientes' && (
        <div style={{ background:t.card, border:`0.5px solid ${t.border}`, borderRadius:20, padding:isMobile?'1.25rem':'1.5rem' }}>
          <SharedTaskList clientId={user?.id} isAdmin={false} clientName={profile?.full_name} />
        </div>
      )}

      {/* COMING SOON MODAL */}
      {showComingSoon && (
        <>
          <div onClick={()=>setShowComingSoon(false)} style={{ position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.5)', zIndex:9998 }}/>
          <div style={{ position:'fixed', top:'50%', left:'50%', transform:'translate(-50%,-50%)', width:'calc(100vw - 3rem)', maxWidth:380, zIndex:9999, background:t.card, borderRadius:20, padding:'2rem', textAlign:'center', boxShadow:'0 20px 60px rgba(0,0,0,0.25)' }}>
            <p style={{ fontSize:32, margin:'0 0 12px' }}>🔜</p>
            <p style={{ fontFamily:serif, fontSize:18, fontWeight:400, margin:'0 0 8px' }}>Próximamente</p>
            <p style={{ fontSize:14, color:t.textSecondary, lineHeight:1.6, margin:'0 0 20px' }}>Esta función estará disponible pronto. Te notificaremos cuando esté lista.</p>
            <button onClick={()=>setShowComingSoon(false)} style={{ background:C.logoGrad, color:'#fff', border:'none', borderRadius:50, padding:'10px 28px', fontSize:14, fontWeight:500, cursor:'pointer', fontFamily:font }}>Entendido</button>
          </div>
        </>
      )}

      {/* RECEIPT MODAL */}
      {receiptSale && (
        <>
          <div onClick={()=>setReceiptSale(null)} style={{ position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.5)', zIndex:9998 }}/>
          <div style={{ position:'fixed', top:'50%', left:'50%', transform:'translate(-50%,-50%)', width:isMobile?'95%':'auto', maxWidth:300, zIndex:9999 }}>
            <div id="td-receipt" style={{ background:'#fff', borderRadius:12, padding:'24px 20px', color:'#000', fontFamily:'monospace', fontSize:12, lineHeight:1.6 }}>
              <div style={{ textAlign:'center', marginBottom:8 }}><p style={{ fontSize:14, fontWeight:700, margin:0 }}>T&D</p><p style={{ fontSize:11, margin:0 }}>{profile?.business_name||'Thinker & Doer'}</p></div>
              <div style={{ borderTop:'1px dashed #ccc', margin:'8px 0' }}/>
              <p style={{ fontWeight:700, margin:'0 0 4px', fontSize:13, textAlign:'center' }}>Folio: {receiptSale.folio}</p>
              <p style={{ margin:'0 0 2px' }}>Fecha: {receiptSale.date}</p>
              <p style={{ margin:'0 0 2px' }}>Hora: {receiptSale.time}</p>
              <div style={{ borderTop:'1px dashed #ccc', margin:'8px 0' }}/>
              <p style={{ margin:'0 0 2px' }}>Producto:</p><p style={{ fontWeight:700, margin:'0 0 4px', fontSize:13 }}>{receiptSale.product}</p>
              <p style={{ margin:'0 0 2px' }}>Precio:</p><p style={{ fontWeight:700, fontSize:16, margin:'0 0 4px' }}>${receiptSale.price.toLocaleString()}</p>
              <p style={{ margin:0 }}>Canal: {receiptSale.channel==='store'?'Mostrador 🏪':'Internet 📱'}</p>
              <div style={{ borderTop:'1px dashed #ccc', margin:'8px 0' }}/>
              <p style={{ textAlign:'center', margin:0, fontSize:11 }}>¡Gracias por tu compra!</p>
            </div>
            <div style={{ display:'flex', gap:6, marginTop:12, flexWrap:'wrap' }}>
              <button onClick={printReceipt} style={{ flex:1, minWidth:80, background:C.logoGrad, color:'#fff', border:'none', borderRadius:50, padding:'10px', fontSize:12, fontWeight:500, cursor:'pointer', fontFamily:font }}>🖨 Imprimir</button>
              <button onClick={downloadPDF} style={{ flex:1, minWidth:80, background:C.turquesa, color:'#fff', border:'none', borderRadius:50, padding:'10px', fontSize:12, fontWeight:500, cursor:'pointer', fontFamily:font }}>📄 PDF</button>
              <button onClick={shareTicket} style={{ flex:1, minWidth:80, background:'#25D366', color:'#fff', border:'none', borderRadius:50, padding:'10px', fontSize:12, fontWeight:500, cursor:'pointer', fontFamily:font }}>📱 Compartir</button>
            </div>
            <button onClick={()=>setReceiptSale(null)} style={{ width:'100%', marginTop:6, background:'none', border:'none', color:t.textSecondary, fontSize:12, cursor:'pointer', fontFamily:font, padding:6 }}>Cerrar</button>
          </div>
        </>
      )}

      {/* Tour removed */}

      {/* LIGHTBOX */}
      {lightbox && (
        <>
          <div onClick={()=>setLightbox(null)} style={{ position:'fixed', top:0, left:0, right:0, bottom:0, background:'rgba(0,0,0,0.8)', zIndex:9998 }}/>
          <div style={{ position:'fixed', top:'50%', left:'50%', transform:'translate(-50%,-50%)', zIndex:9999, textAlign:'center' }}>
            <div style={{ width:isMobile?280:400, height:isMobile?200:280, borderRadius:20, background:`linear-gradient(135deg, ${C.turquesa}20, ${C.mango}15, ${C.coral}20)`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:80, marginBottom:16 }}>{lightbox.thumb}</div>
            <p style={{ color:'#fff', fontSize:16, fontWeight:500, margin:'0 0 8px' }}>{lightbox.titulo}</p>
            <div style={{ display:'flex', gap:10, justifyContent:'center' }}>
              <button style={{ background:C.logoGrad, color:'#fff', border:'none', borderRadius:50, padding:'10px 24px', fontSize:13, fontWeight:500, cursor:'pointer', fontFamily:font }}>Publicar en redes</button>
              <button onClick={()=>setLightbox(null)} style={{ background:'rgba(255,255,255,0.15)', color:'#fff', border:'none', borderRadius:50, padding:'10px 24px', fontSize:13, cursor:'pointer', fontFamily:font }}>Cerrar</button>
            </div>
          </div>
        </>
      )}

      {/* GENIO & LUCA BUBBLE */}
      <div onClick={()=>setChatOpen(!chatOpen)} style={{ position:'fixed', bottom:isMobile?16:24, right:isMobile?16:24, zIndex:200, width:56, height:56, borderRadius:'50%', background:C.triGrad, cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center', boxShadow:'0 6px 24px rgba(93,193,185,0.3)', transition:'transform 0.3s cubic-bezier(0.34,1.56,0.64,1)' }} onMouseEnter={e=>e.currentTarget.style.transform='scale(1.1)'} onMouseLeave={e=>e.currentTarget.style.transform='scale(1)'}>
        <span style={{ fontSize:14, fontWeight:700, color:'#fff' }}>⚡◆</span>
      </div>
      {chatOpen && (
        <div style={{ position:'fixed', bottom:isMobile?80:88, right:isMobile?16:24, zIndex:200, width:isMobile?'calc(100vw - 2rem)':'340px', maxHeight:420, background:t.card, borderRadius:20, overflow:'hidden', boxShadow:'0 12px 48px rgba(0,0,0,0.15)', border:`0.5px solid ${t.border}`, display:'flex', flexDirection:'column' }}>
          <div style={{ padding:'14px 18px', borderBottom:`0.5px solid ${t.border}`, display:'flex', alignItems:'center', gap:8 }}>
            <div style={{ width:28, height:28, borderRadius:'50%', background:`linear-gradient(135deg, ${C.mango}, ${C.coral})`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:12 }}>⚡</div>
            <div style={{ width:28, height:28, borderRadius:'50%', background:`linear-gradient(135deg, ${C.turquesa}, ${C.mango})`, display:'flex', alignItems:'center', justifyContent:'center', fontSize:12 }}>◆</div>
            <div style={{ flex:1 }}><p style={{ fontSize:13, fontWeight:500, margin:0 }}>Genio & Luca</p><p style={{ fontSize:10, color:t.textSecondary, margin:0 }}>Tus compañeros en este viaje</p></div>
            <button onClick={()=>setChatOpen(false)} style={{ background:'none', border:'none', color:t.textSecondary, fontSize:18, cursor:'pointer', padding:0 }}>×</button>
          </div>
          <div style={{ flex:1, overflowY:'auto', padding:'12px 14px', minHeight:200 }}>
            {chatMsgs.length===0 && !chatLoading && (
              <div style={{ display:'flex', flexDirection:'column', alignItems:'center', justifyContent:'center', height:'100%', minHeight:160, color:t.textSecondary, textAlign:'center' }}>
                <p style={{ fontSize:28, margin:'0 0 8px' }}>✨</p>
                <p style={{ fontSize:13, margin:0 }}>Escríbeles algo a Genio & Luca...</p>
              </div>
            )}
            {chatMsgs.map((m,i)=>(
              <div key={i} style={{ marginBottom:12 }}>
                <p style={{ fontSize:12, fontWeight:600, color:m.color, margin:'0 0 3px' }}>{m.autor}</p>
                <div style={{ background:t.isDark?'#333':m.color+'10', borderRadius:'4px 14px 14px 14px', padding:'10px 13px', fontSize:13, lineHeight:1.6 }}>{m.texto}</div>
              </div>
            ))}
            {chatLoading && <p style={{ fontSize:12, color:t.textSecondary, margin:0, fontStyle:'italic' }}>Genio y Luca están pensando...</p>}
          </div>
          <div style={{ borderTop:`0.5px solid ${t.border}`, padding:'10px 14px', display:'flex', gap:8 }}>
            <input value={chatInput} onChange={e=>setChatInput(e.target.value)} onKeyDown={e=>{if(e.key==='Enter'){sendMessage(chatInput);setChatInput('')}}} placeholder="Escríbeles algo..." style={{ flex:1, padding:'9px 12px', border:`0.5px solid ${t.border}`, borderRadius:10, fontSize:13, fontFamily:font, outline:'none', background:t.inputBg, color:t.text }}/>
            <button onClick={()=>{sendMessage(chatInput);setChatInput('')}} disabled={chatLoading} style={{ background:C.logoGrad, color:'#fff', border:'none', borderRadius:10, padding:'9px 16px', fontSize:13, fontWeight:500, cursor:'pointer', fontFamily:font, opacity:chatLoading?0.6:1 }}>{chatLoading?'...':'→'}</button>
          </div>
        </div>
      )}
      <PushPrompt />
    </SidebarLayout>
    </ProfileGate>
  );
}
